import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--charcoal)] px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/assets/seraphina-logo-hero.png" alt="Seraphina" className="h-16 w-16 object-contain mx-auto mb-4" />
          <h1 className="font-display text-4xl text-[#F3E9DC]">Seraphina Analytics</h1>
          <p className="text-[#c9bba9] text-sm mt-2 tracking-widest uppercase">Private Owner Dashboard</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-[#46413b] rounded-2xl p-8 border border-[#5a544c]">
          <label className="eyebrow text-[var(--gold-soft)]">Email</label>
          <Input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-2 mb-5 bg-[#3B3733] border-[#5a544c] text-[#F3E9DC]"
            placeholder="you@example.com"
          />
          <label className="eyebrow text-[var(--gold-soft)]">Password</label>
          <Input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mt-2 mb-6 bg-[#3B3733] border-[#5a544c] text-[#F3E9DC]"
            placeholder="••••••••"
          />
          {error && <p data-testid="login-error" className="text-red-300 text-sm mb-4">{error}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="btn-gold rounded-full w-full py-3.5 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-center text-[#c9bba9] text-xs mt-4">
          <Link to="/admin/forgot" data-testid="forgot-password-link" className="hover:text-[var(--gold-soft)] transition-colors">Forgot password?</Link>
        </p>
        <p className="text-center text-[#c9bba9] text-xs mt-2">
          <a href="/" className="hover:text-[var(--gold-soft)] transition-colors">← Back to site</a>
        </p>
      </div>
    </div>
  );
}
